import type { AppAction, VrModeAction } from '../AppAction';

import { _fakeMessage } from '../Communication';

import { timeout } from '@egr/xbox/utils/Promise';
import { getEnvVar } from '@egr/xbox/utils/ReactScriptHelper';
import { Logger } from '@egr/xbox/utils/errors/Logger';

import { ajax } from '@easterngraphics/wcf/modules/utils/async';

const ArStream = new class ArEventStream {
    private started: boolean = false;
    private contentPromise: Promise<string | undefined>;

    public constructor() {
        const streamUrl = getEnvVar('DEBUG_AR_STREAM', '');
        this.contentPromise = streamUrl.startsWith('http') ? ajax('GET', streamUrl, null, {
            responseType: 'text'
        }) : Promise.resolve(undefined);
    }

    public async start(): Promise<void> {
        this.started = true;
        const content = await this.contentPromise;
        if (content == null) {
            this.started = false;
            return;
        }

        const lines = content.match(/[^\r\n]+/g);
        if (lines == null) {
            this.started = false;
            return;
        }

        for (const line of lines) {
            if (this.wasCanceled) {
                return;
            }

            // eslint-disable-next-line no-restricted-properties
            _fakeMessage(JSON.parse(line));
            await timeout(50);
        }
    }

    public stop() {
        this.started = false;
    }

    private get wasCanceled(): boolean {
        return this.started !== true;
    }
};

export function debugArAppActionHandler(data: AppAction<VrModeAction>) {
    switch (data.arguments) {
        case 'enter':
            void ArStream.start();
            break;
        case 'leave':
            ArStream.stop();
            break;
        default:
            Logger.warn('Unsupported AR mode:', data.action);
            break;
    }
}